export default __webpack_public_path__ + "static/media/defaultAvatar.a904636e.png";